import { OperatingSystem } from "../../models";
import { PROCESSES } from "../prototype/os-data";

/** Operating systems — mapped from the prototype PROCESSES (source of truth, incl. R/A/C/P seats). */
export const OPERATING_SYSTEMS_SEED: readonly OperatingSystem[] = Object.values(
  PROCESSES as Record<string, any>,
).map(
  (proc): OperatingSystem => ({
    id: proc.id,
    name: proc.name,
    long: proc.long ?? proc.name,
    phases: (proc.phases ?? []).map((ph: any) => ({
      num: ph.num,
      label: ph.label,
      dur: String(ph.dur ?? ""),
      desc: ph.desc ?? "",
      seats: (ph.seats ?? []).map((s: any) => ({ position: s.position, role: s.role })),
    })),
  }),
);
